
import React from 'react';
import Layout from '@/components/Layout/Layout';
import ForceConverter from '@/components/UnitConverter/ForceConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ForceConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Force Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of force, from newtons to pound-force and more.
          </p>
        </div>
        
        <div className="mb-8">
          <ForceConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Force Converter</h2>
          <p>
            Our force converter tool enables you to convert between different units of force used 
            in physics, engineering, and mechanical applications. Force, a fundamental concept in physics, 
            is the interaction that causes an object with mass to change its velocity or shape.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Force Unit Conversions</h3>
          <p>
            Some of the most frequently used force conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between newtons and pound-force</li>
            <li>Converting kilonewtons to pound-force (construction and engineering)</li>
            <li>Converting between dynes and newtons (scientific applications)</li>
            <li>Converting between different weight-based force units</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Force Converter</h3>
          <p>
            Using our force converter is simple:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the force unit you're converting from</li>
            <li>Select the force unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The force converter supports a comprehensive range of units, including newtons (N), kilonewtons (kN), 
            pound-force (lbf), kilogram-force (kgf), ton-force, dynes, and more. Whether you're working on 
            physics problems, engineering calculations, or mechanical design, our converter provides accurate 
            conversions between all common force units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default ForceConverterPage;
